import React from 'react';

/**
 * Tabs — underline-style tab row.
 *
 * tabs:     Array<{ key: string, label: string, Icon?: LucideIcon }>
 * value:    currently active key
 * onChange: (key) => void
 */
export function Tabs({ tabs = [], value, onChange }) {
  return (
    <div className="flex">
      {tabs.map(({ key, label, Icon }) => (
        <button
          key={key}
          onClick={() => onChange(key)}
          className={`flex items-center gap-1.5 px-4 py-2.5 text-[12.5px] font-medium border-b-2 transition ${
            value === key
              ? 'border-primary text-primary'
              : 'border-transparent text-slate-500 hover:text-slate-700'
          }`}
        >
          {Icon && <Icon size={13} strokeWidth={1.75} />}
          {label}
        </button>
      ))}
    </div>
  );
}

export default Tabs;
